import { render } from "./ContentPolicyBase.vue?vue&type=template&id=4c0bf268&scoped=true"
import script from "./ContentPolicyBase.vue?vue&type=script&lang=js"
export * from "./ContentPolicyBase.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c0bf268"]])

export default __exports__